
import { Reagent } from "@/types/reagent.types";

/**
 * Maps database reagent data to the Reagent interface
 * Used to standardize the mapping across all services
 */
export function mapReagentData(item: any): Reagent {
  return {
    id: item.id,
    name: item.name,
    description: item.description || "",
    amount: item.amount ? item.amount.toString() : "",
    imageUrl: item.image_url || "",
    dateAdded: item.created_at || "",
    expiryDate: item.expiry_date || null,
    available: item.available,
    // Original database fields
    amount_unit: item.amount_unit,
    catalogue_number: item.catalogue_number,
    category_id: item.category_id,
    created_at: item.created_at,
    updated_at: item.updated_at,
    storage_conditions: item.storage_conditions,
    number_of_packages: item.number_of_packages,
    expiry_date: item.expiry_date,
    image_url: item.image_url,
    user_id: item.user_id,
    // Mapped fields (camelCase versions of snake_case)
    catalogNumber: item.catalogue_number || "",
    category: item.category_id || "",
    storageConditions: item.storage_conditions || "",
    numberOfPackages: item.number_of_packages ? item.number_of_packages.toString() : "",
    // Profile-related fields
    userName: item.profiles?.username || "",
    labName: item.profiles?.lab || "",
    university: item.profiles?.university || "",
    city: item.city || item.profiles?.city || "",
    country: item.country || item.profiles?.country || "",
    // Add is_deleted property if it doesn't exist
    is_deleted: item.is_deleted || false,
    // Make sure profiles is present
    profiles: item.profiles ? {
      id: item.profiles.id,
      username: item.profiles.username,
      display_username: item.profiles.display_username,
      lab: item.profiles.lab,
      university: item.profiles.university,
      location: item.profiles.location,
      city: item.profiles.city,
      country: item.profiles.country
    } : undefined,
    // Add categories relation if available
    categories: item.categories
  };
}

/**
 * Maps an array of database reagent data to Reagent[] array
 */
export function mapReagentArray(items: any[]): Reagent[] {
  return items.map(item => mapReagentData(item));
}
